import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListCustomerDocumentsInput } from "@nexxt/contracts/documents";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the customer's documents (ADR-220): one factory, the same keys for the loader and the screens.

const documents = api.documents.documents;

type ListPage = InferResponseType<typeof documents.$get, 200>;
export type CustomerDocument = ListPage["items"][number];

/** The filters of the list (`listCustomerDocumentsInput`), without the paging the query adds. */
export type DocumentFilters = Pick<ListCustomerDocumentsInput, "type" | "q" | "salesOrder">;

const PAGE_SIZE = 25;

export const documentQueries = {
  all: ["documents"] as const,

  list: (filters: DocumentFilters) =>
    infiniteQueryOptions({
      queryKey: ["documents", "list", filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          documents.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};

/** Where the PDF of a document is downloaded, as an attachment (the same origin, with the session cookie). */
export const pdfHref = (documentId: string): string =>
  api.documents.documents[":documentId"].pdf.$url({ param: { documentId } }).href;
